import React, { Component } from "react";
import styles from "./css/AppAddComp.module.css";

export class AppAddComp extends Component {
  render() {
    return (
      <div className={styles.appAddComp}>
        <div className={styles.appAddCompInner}>
          <div className={styles.coverImageCont}>
            <div
              className={styles.coverImage}
              style={{
                backgroundImage: `linear-gradient(105.26deg, rgba(0, 0, 0, 0) -0.82%, rgba(0, 0, 0, 0.5) 100%), url("/assets/img/appAdd.png")`,
              }}
            ></div>
            <div className={styles.frontBlock}>
              <div className={styles.frontBlockLeft}>
                <div className={styles.mobileImageCont}>
                  <img src="/assets/img/mobileImage.png" />
                </div>
              </div>
              <div className={styles.frontBlockRight}>
                <div className={styles.frontBlockRightInner}>
                  <div className={styles.frontBlockRightHeading}>
                    <p>Download our app and Exclusive Feature</p>
                  </div>
                  <div className={styles.downloadBy}>
                    <div className={styles.downloadByGoogle}>
                      <div className={styles.googlePlayIcon}>
                        <div >
                          <img src="/assets/icons/google-play.png" />
                        </div>
                      </div>
                      <div>
                        <div>
                          <span>Download by</span>
                        </div>
                        <div style={{ fontSize: "16px", marginTop: "2px" }}>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </div>
                    <div className={styles.downloadByApple}>
                      <div className={styles.appleIcon}>
                        <div>
                          <img src="/assets/icons/apple.svg" />
                        </div>
                      </div>
                      <div>
                        <div>
                          <span>Download by</span>
                        </div>
                        <div style={{ fontSize: "16px", marginTop: "2px" }}>
                          <span>App Store</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AppAddComp;
